import React from 'react'

/**
 * Generic fixed vertical menu bar (left rail).
 *
 * @param {ReactNode} top - content pinned to the top of the bar
 * @param {ReactNode} bottom - content pinned to the bottom of the bar
 * @param {string} className - extra class on the root element
 */
const VerticalMenuBar = ({ top, bottom, className }) => {
    return (
        <nav className={`bimmatch-vertical-menu-bar ${className || ""}`}>
            <div className="vertical-menu-bar-top">{top}</div>
            <div className="vertical-menu-bar-bottom">{bottom}</div>
        </nav>
    )
}

export default VerticalMenuBar
